module.exports = __webpack_public_path__ + "img/spin3.a19d6def.png";